import { createStaticReplacer } from "./regexTools.mjs";
const escapeHtml = createStaticReplacer({
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#039;"
});
export {
  escapeHtml
};
//# sourceMappingURL=escapeHtml.mjs.map
